/* eslint-disable import/order */
import { planIncrementEntryPoint } from '@jira/spa-apps__advanced-roadmaps-plan-increment/src/planIncrementEntryPoint.entrypoint.tsx';
import {
	advancedRoadmapsPlanPageInitialChecksResource,
	advancedRoadmapsReduxStoreStateResource,
} from '@jira/router-resources__advanced-roadmaps-plan/src/advancedRoadmapsPlanPageInitialChecksResource.tsx';
import { getPlansBacklogResource } from '@jira/router-resources__advanced-roadmaps-plan/src/plansBacklogResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { createLayout } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { arjIncrementEmbedRoute } from '@jira/router-routes__advanced-roadmaps-embed-routes/src/arjIncrementEmbedRoute.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { PlanIncrementEmbedPage, LazyPlanIncrementEmbed } from './ui/index.tsx';

const planProgramEmbedRouteEntry = createChromelessEntryPoint({
	main: planIncrementEntryPoint,
});

export const arjIncrementEmbedRouteEntry: Route = createEntry(arjIncrementEmbedRoute, () => ({
	group: 'software',
	// eslint-disable-next-line no-restricted-syntax
	component: PlanIncrementEmbedPage,
	entryPoint: () => planProgramEmbedRouteEntry,

	layout: createLayout({
		isChromeless: true,
	}),

	resources: [
		advancedRoadmapsPlanPageInitialChecksResource,
		...getPlansBacklogResource(),
		advancedRoadmapsReduxStoreStateResource,
		...jiraSpaResources(),
	],

	preloadOptions: {
		earlyChunks: ['advanced-roadmaps-early-entry'],
	},

	forPaint: [LazyPlanIncrementEmbed],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
